import { render, staticRenderFns } from "./IconCustomer.vue?vue&type=template&id=732adb7c&scoped=true"
import script from "./IconCustomer.vue?vue&type=script&lang=js"
export * from "./IconCustomer.vue?vue&type=script&lang=js"
import style0 from "./IconCustomer.vue?vue&type=style&index=0&id=732adb7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732adb7c",
  null
  
)

export default component.exports